import { useDisclosure } from '@mantine/hooks';
import { BaseSlido } from '@modules/core/components/BaseSlido';
import {
  Box, Button, Flex, Text
} from '@huspy/briks-web';
import { ArrowUpRight } from '@huspy/briks-icons';
import { Checkbox } from '@mantine/core';
import { useState } from 'react';
import useUpdateBrokerTnCs from '@modules/core/hooks/mutations/useUpdateBrokerTnCs';
import { useGlobalStore } from '@modules/core/store';
import { useTranslation } from 'react-i18next';
import {
  PrivacyPolicyRoute,
  TermsAndConditionsRoute,
  TutorialsRoute
} from '@modules/core/presentation/v2/routes';
import { useLocation, useNavigate } from '@tanstack/react-router';
import { slidoDeepLink } from '@modules/core/utils';

const baseTranslation = 'account.legalAcceptanceForm';
export const LegalAcceptanceForm = ({ hasAcceptedTnC }: {
  hasAcceptedTnC: boolean;
}) => {
  const { hash } = useLocation();
  const shouldOpenSlido = !hasAcceptedTnC || hash === slidoDeepLink.TERMS_AND_CONDITIONS;
  const [opened, { close }] = useDisclosure(shouldOpenSlido);
  const { t } = useTranslation();
  const [checked, setChecked] = useState(false);
  const { user } = useGlobalStore();
  const { mutateAsync, isPending } = useUpdateBrokerTnCs(user?.id!);
  const navigate = useNavigate();

  return (
    <BaseSlido
      title={ (
        <Flex direction='column' gap='2' p='8'>
          <Text size='3xl'>{t(`${baseTranslation}.header`)}</Text>
          <Text size='md' color='neutral.500'>
            {t(`${baseTranslation}.subheader`)}
          </Text>
        </Flex>
      ) }
      close={ () => {} }
      showCloseButton={ false }
      opened={ opened }
      footer={ (
        <Flex justify='end'>
          <Button
            variant={ isPending ? 'outline' : 'primary' }
            disabled={ !checked }
            loading={ isPending }
            onClick={ async () => {
              await mutateAsync();
              navigate({ to: TutorialsRoute.to });
              close();
            } }
          >
            {t(`${baseTranslation}.agreeBtn`)}
          </Button>
        </Flex>
      ) }
      size='lg'
    >
      <Flex h='100%' direction='column' gap='spacing-14' p='8'>
        <Box>
          <Text size='2xl'>{t(`${baseTranslation}.title`)}</Text>
          <Text size='md' color='neutral.500'>
            {t(`${baseTranslation}.subtitle`)}
          </Text>
        </Box>
        <Flex gap='4'>
          <Button
            w='50%'
            variant='secondary'
            onClick={ () => {
              window.open(PrivacyPolicyRoute.to, '_blank');
            } }
          >
            <Flex w='100%' justify='space-between'>
              <Text>{t(`${baseTranslation}.privacyBtn`)}</Text>
              <ArrowUpRight />
            </Flex>
          </Button>
          <Button
            w='50%'
            variant='secondary'
            onClick={ () => {
              window.open(TermsAndConditionsRoute.to, '_blank');
            } }
          >
            <Flex w='100%' justify='space-between'>
              <Text>{t(`${baseTranslation}.tncBtn`)}</Text>
              <ArrowUpRight />
            </Flex>
          </Button>
        </Flex>
        <Checkbox
          onChange={ (event) => setChecked(event.currentTarget.checked) }
          label={ t(`${baseTranslation}.checkBoxLabel`) }
        />
      </Flex>
    </BaseSlido>
  );
};
